export const COIN_LOGOS = {
  BTC: "https://cryptologos.cc/logos/bitcoin-btc-logo.svg?v=032",
  ETH: "https://cryptologos.cc/logos/ethereum-eth-logo.svg?v=032",
  USDT: "https://cryptologos.cc/logos/tether-usdt-logo.svg?v=032",
  USDC: "https://cryptologos.cc/logos/usd-coin-usdc-logo.svg?v=032",
  SOL: "https://cryptologos.cc/logos/solana-sol-logo.svg?v=032",
};

export const COIN_COLORS = {
  BTC: "#F7931A",
  ETH: "#627EEA",
  USDT: "#26A17B",
  USDC: "#2775CA",
  SOL: "#14F195",
};

export function formatTRY(v) {
  if (v == null || isNaN(v)) return "0,00 ₺";
  const n = new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
  return `${n} ₺`;
}

export function formatCrypto(v, symbol) {
  if (v == null || isNaN(v)) return "-";
  const num = Number(v);
  const s = num < 1 ? num.toFixed(6) : num.toFixed(4);
  return `${s.replace(/\.?0+$/, "")} ${symbol || ""}`.trim();
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("tr-TR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export const STATUS_LABELS = {
  created: "Oluşturuldu",
  waiting: "Ödeme Bekleniyor",
  detected: "Ödeme Algılandı",
  confirming: "Blockchain Doğrulanıyor",
  confirmed: "Ödeme Başarılı",
  expired: "Ödeme Süresi Doldu",
  failed: "Ödeme Başarısız",
  cancelled: "İptal Edildi",
};

export const STATUS_TONE = {
  created: "muted",
  waiting: "warning",
  detected: "info",
  confirming: "info",
  confirmed: "success",
  expired: "muted",
  failed: "danger",
  cancelled: "muted",
};

export const PAYOUT_STATUS = {
  pending: "Bekliyor",
  processing: "İşleniyor",
  completed: "Tamamlandı",
  failed: "Başarısız",
};

export function truncate(str, n = 12) {
  if (!str) return "-";
  if (str.length <= n * 2) return str;
  return `${str.slice(0, n)}...${str.slice(-6)}`;
}
